var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbnail)?_c('q-img',{attrs:{"src":_vm.thumbnail,"contain":"","spinner-size":"20px"},on:{"click":function($event){$event.stopPropagation();return _vm.showImage(_vm.src)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }